import {HttpClient, HttpParams} from '@angular/common/http';
import {Injectable, OnDestroy} from '@angular/core';
import {Observable, Subject} from 'rxjs';
import {DataSourceResponse, DataSourceService} from './DataSourceService';
import {takeUntil, tap} from 'rxjs/operators';
import {SwalService} from '~local/app/shared/services/SwalService';
import {downloadFile} from '~shared/utils/utils';
import {TicketAttachmentEntity, TicketDto, TicketStatus} from '~shared/types/ticket.types';

@Injectable()
export class TicketService extends DataSourceService<TicketDto> implements OnDestroy{

    private readonly destroy$ = new Subject<void>();

    constructor(
        private readonly http: HttpClient,
        private readonly swalService: SwalService
    ) {
        super();
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    public loadData(
        filter: string = '',
        orderBy: string = '',
        orderDirection: string = 'ASC',
        pageNumber: number = 0,
        pageSize: number = 10
    ): Observable<DataSourceResponse<TicketDto>> {
        return this.http.get<DataSourceResponse<TicketDto>>('/admin/tickets/list', {
            params: new HttpParams()
                .set('filter', filter)
                .set('orderBy', orderBy)
                .set('sort', orderDirection.toUpperCase())
                .set('skip', pageNumber.toString())
                .set('take', pageSize.toString())
        });
    }

    public  getTicket(id: number): Observable<TicketDto> {
        return this.http.get<TicketDto>('/admin/tickets/' + id).pipe(
            tap({
                next: () => {},
                error: (err) => {
                    this.swalService.showException(err);
                }
            })
        );
    }

    public create(formData: FormData): Observable<{status: 'success'}> {
        return this.http.post<{status: 'success'}>('/admin/tickets', formData).pipe(
            tap({
                next: () => {},
                error: (err) => {
                    this.swalService.showException(err);
                }
            })
        );
    }

    public  sendMessage(fromData: FormData): Observable<TicketDto> {
        return this.http.post<TicketDto>('/admin/tickets/replay/', fromData);
    }

    public changeTicketStatus(ticketId: number, status: TicketStatus): Observable<{status: 'success'}> {
        return this.http.post<{status: 'success'}>('/admin/tickets/status/', { ticketId, status });
    }

    public downloadAttachment(ticketId: number, attachment: TicketAttachmentEntity): void {
        try {
            this.http.get('/admin/tickets/attachment/' + ticketId + '/' + attachment.key, {responseType: 'blob'})
                .pipe(takeUntil(this.destroy$))
                .subscribe(fileBlob => {
                    downloadFile(fileBlob, attachment.name);
                });
        } catch (err) {
            this.swalService.showException(err);
        }
    }
}
